import { FelaCSS } from '@bridebook/ui';

interface IStyle {
  button: FelaCSS;
}

const style = (): IStyle => ({
  button: {
    position: 'fixed',
    bottom: 'calc(20px + env(safe-area-inset-bottom))',
    zIndex: 100,
    left: '50%',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap',
  },
});

export default style;
